export * from "./clsx";
export * from "./referral";
export * from "./type";

export function getErrorMessage(error: unknown): string | undefined {
  return error instanceof Error ? error.message : undefined;
}

export function onBtnClick(
  f: () => Promise<void> | void,
  errorHandler?: (e: any) => void
): (e: React.MouseEvent) => void {
  return (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    Promise.resolve(f()).catch((e) => {
      console.log("[BtnClick] got error", e);
      if (errorHandler) errorHandler(e);
    });
  };
}

export function sanitizeHtml(text?: string): string {
  return (
    text
      ?.replace(
        /(\r?\n|\r|\s+|\s*class="[^"]*"|\s*style="[^"]*"|<br\s*\/?>|<img\b[^>]*>|<image\b[^>]*>)+/gi,
        " "
      )
      .trim() || ""
  );
}
